module.exports = __webpack_public_path__ + "static/media/kenzo-tiger.a9d56b8b.png";